module.exports = __webpack_public_path__ + "static/media/goToDef_demo.8745c2be.gif";